<template>
  <ion-page style="background: var(--ion-color-primary)">
    <ion-header class="ion-no-border">
      <ion-toolbar color="primary" class="-not-fixed" style="">
        <ion-buttons slot="start"
          ><ion-button
            v-if="routing === 'cancel'"
            @click="modalController.dismiss()"
            color="light">
            <ion-icon
              :src="require('@lib/assets/icons/icon_zurueck.svg')"
              slot="icon-only"></ion-icon> </ion-button
        ></ion-buttons>
        <ion-button
          slot="end"
          @click="$store.commit('setOpenMenu', true)"
          fill="clear"
          size="large"
          class="ion-hide-md-up"
          ><ion-icon
            slot="icon-only"
            :src="require('@lib/assets/icons/menu-white.svg')"
            size="large"></ion-icon
        ></ion-button>
      </ion-toolbar>
    </ion-header>
    <ion-content ref="content">
      <ion-grid
        class="ion-padding"
        style="display: flex; flex-direction: column; min-height: 100%">
        <ion-row
          style="flex-grow: 1"
          class="ion-text-center ion-align-items-center">
          <ion-col size="12">
            <!-- <ion-icon
              :src="require('@lib/assets/icons/roodie-white.svg')"
              size="large"
              color="light"
            /> -->
            <roodie
              fillInner="#5E58BE"
              fillOuter="#FFF"
              :expression="routing === 'cancel' ? 'meh' : 'happy'" />
            <template v-if="routing === 'Medgate'">
              <p>
                <b
                  >Sie wechseln nun zu Medgate, dem Spezialisten für
                  Fernbehandlung.</b
                >
              </p>
              <p>
                Sie sind hier in den besten Händen - für eine rasche Genesung.
                Zu Ihrem persönlichen Schutz bedarf es bei Fernbehandlungen der
                gesonderten Anmeldung in der Medgate App.
              </p>
              <p>
                Gleich anschließend können Sie direkt in der App einen Termin
                für das Arztgespräch buchen.
              </p>
              <p><b>Alles Gute für Ihre Genesung!</b></p>
            </template>
            <template v-else-if="routing === 'BetterDoc'">
              <p>
                <b>Geschafft!</b>
              </p>
              <p>
                <b>
                  Ein/e Kollege/in aus dem medizinischen Team* meldet sich in
                  Kürze telefonisch bei Ihnen, um noch ein paar Details für die
                  gezielte Arztsuche zu erfragen.</b
                >
              </p>
              <p v-if="!shouldOpenFormContact">
                <b>Wir wünschen Ihnen alles Gute für Ihre Genesung!</b>
              </p>
            </template>
            <template v-else-if="routing === 'Quality Smile'">
              <p>
                <b>Geschafft!</b>
              </p>
              <p>
                Ein/e Kollege/in aus dem Patientenservice* meldet sich in Kürze
                bei Ihnen.
              </p>
              <p>
                <b>Bitte um etwas Geduld!</b>
              </p>
            </template>
            <template v-else-if="routing === 'ZTK'">
              <template v-if="ztkBookingText">
                <template v-if="ztkBookingText === 'Termin buchen'">
                  <b>
                    <p>
                      Ihr Termin in der Zahnärztlichen Tagesklinik
                      {{ ztkBookingLocation }} findet am
                    </p>
                    <p>
                      1. Juli 2021
                      <br />
                      12:30 Uhr
                    </p>
                    statt.
                  </b>
                  <p>
                    Ihr behandelnder Arzt:<br />
                    Dr. Ernst Dent<br />
                    Teststraße 23<br />
                    80000 Testort
                  </p>
                </template>
                <template v-else>
                  <p>
                    <b>
                      Wir haben Ihre Anfrage an die Zahnärztliche Tagesklinik
                      {{ ztkBookingLocation }} weitergeleitet.
                    </b>
                  </p>
                  <p>Sie werden in Kürze von den Kollegen kontaktiert.</p>
                  <p>Wir wünschen Ihnen alles Gute!</p>
                </template>
              </template>
              <template v-else-if="ztkBookingLocation">
                <p>
                  <b>Sie werden direkt zur Terminbuchung weitergeleitet.</b>
                </p>
                <p>
                  <b>Zahnärztliche Tagesklinik {{ ztkBookingLocation.name }}</b
                  ><br />
                  {{ ztkBookingLocation.address.street }}
                  {{ ztkBookingLocation.address.housenumber }}<br />
                  {{ ztkBookingLocation.address.zip }} -
                  {{ ztkBookingLocation.address.city }}
                </p>
                <p>Wir wünschen Ihnen alles Gute!</p>
                <!-- <ion-spinner></ion-spinner> -->
              </template>
              <template v-else>
                <p><b>Vielen Dank für Ihr Verständnis!</b></p>
                <p>
                  Möchten Sie informiert werden, wenn wir in Ihrer Region
                  passende Zahnärzte anbieten können?
                </p>
                <ion-button
                  fill="outline"
                  color="light"
                  @click="addUserTag('dentist-north-germany')"
                  >Ja, bitte um Info</ion-button
                >
              </template>
            </template>
            <template v-else-if="routing === 'afterZTK'">
              <p>Wir wünschen Ihnen alles Gute!</p>
            </template>
            <template v-else-if="routing === 'afterDentistNorthGermanyTag'">
              <p>
                Wir informieren Sie, sobald wir in Ihrer Region passende
                Zahnärzte anbieten können und wünschen Ihnen alles Gute!
              </p>
            </template>
            <template
              v-else-if="
                routing === 'ARAG Case Management Zahn' &&
                ['toothTreatmentplan'].includes(selectedCondition?.name)
              ">
              <p>
                <b v-if="hasTreatmentplan"
                  >Wir haben Ihren Heil- und Kostenplan an die
                  Gesundheitsassistenten der ARAG weitergeleitet.
                </b>
                <b v-else
                  >Wir haben Ihre Anfrage an die Gesundheitsassistenten der ARAG
                  weitergeleitet.</b
                >
              </p>
              <p>Sie werden in Kürze von den Kollegen kontaktiert.</p>
              <p>Wir wünschen Ihnen alles Gute!</p>
            </template>
            <template v-else-if="routing.startsWith('ARAG Case Management')">
              <p>
                <b>Geschafft!</b>
              </p>
              <p>
                <b
                  >Ein ARAG Gesundheitsassistent meldet sich in Kürze
                  telefonisch bei Ihnen, um Ihr Anliegen zu besprechen.</b
                >
              </p>
              <p><b>Wir wünschen Ihnen alles Gute für Ihre Genesung!</b></p>
            </template>
            <template v-else-if="shouldOpenInteliwiseModal">
              <p>
                <b>Die Experten von BetterDoc kümmern sich um Ihr Anliegen.</b>
              </p>
              <p>Wir wünschen Ihnen alles Gute für Ihre Genesung!</p>
            </template>
            <template v-else-if="routing === 'cancel'">
              <p><b>Sie möchten die Suche beenden?</b></p>
              <p>
                Wenn Sie die Suche hier abbrechen und das Service der
                Arzt-/Kliniksuche nicht nutzen möchten, nimmt sich gerne
                <a
                  href="#"
                  @click.prevent="
                    modalController.dismiss({
                      newRouting: shouldOpenFormContact
                        ? 'ARAG Case Management Mental'
                        : 'ARAG Case Management',
                    })
                  "
                  style="color: white"
                  >das Team des ARAG Gesundheitsservices</a
                >
                Ihrem Anliegen an, um die bestmögliche Lösung für Sie zu finden.
              </p>
            </template>
            <template v-else-if="routing === 'cancelMessage'">
              <p>
                Wir wünschen Ihnen alles Gute für Ihre Behandlung! Bei Bedarf
                können wir Sie auch zu einem späteren Zeitpunkt bei der Suche
                unterstützen.
              </p>
              <p>Ihr Roodie-Team</p>
            </template>
            <template v-else>
              <p v-if="routing !== '' && routing !== 'afterCoaching'">
                <b v-if="routing === 'Medgate'">
                  Sie werden direkt zu Medgate weitergeleitet.
                </b>
                <b v-else
                  >Ein/e
                  {{ routing === "Medgate" ? "Arzt/Ärztin" : "Experte/in" }} von
                  {{ routing }} meldet sich in Kürze bei Ihnen.</b
                >
              </p>
              <p v-if="!shouldOpenCoaching || routing === 'afterCoaching'">
                Wir wünschen Ihnen alles Gute für Ihre Genesung!
              </p>
            </template>
          </ion-col>
          <ion-col size="12">
            <ion-button
              color="light"
              fill="outline"
              @click="modalController.dismiss()"
              v-if="routing === 'ZTK' && ztkBookingText === 'Termin buchen'">
              In Kalender übernehmen
            </ion-button>
            <br />
            <template v-if="routing === 'cancel'">
              <p>
                Speichern Sie Ihren Roodie.Check - er wird im Menü unter
                Roodie.Safe für Sie abgelegt. So haben Sie diesen immer
                griffbereit!
              </p>
              <ion-item
                class="u-item-white ion-text-center u-inline-block"
                lines="none">
                <ion-checkbox
                  style="margin-right: 5px"
                  slot="start"
                  v-model="shouldSave">
                </ion-checkbox>
                <ion-label class="ion-text-wrap" color="primary">
                  Ich möchte meinen Roodie.Check {{ filesText }}speichern und
                  akzeptiere die
                  <u class="u-bold"
                    ><a
                      href="#"
                      @click.prevent="
                        $browser.open({
                          url: 'https://www.roodie-health.com/arag/datenschutz',
                        })
                      "
                      >Datenschutzinformationen</a
                    ></u
                  >.
                  <a
                    href="#"
                    @click.prevent="openInfoModal(privacy3Text)"
                    style="text-decoration: none"
                    >MEHR</a
                  >
                </ion-label>
              </ion-item>
              <div>
                <ion-button
                  :disabled="!shouldSave"
                  class="ion-margin-top"
                  color="light"
                  fill="outline"
                  @click="modalController.dismiss({ shouldSaveCheck: true })"
                  >Roodie.Check speichern</ion-button
                >
                <br />
                <ion-button
                  class="ion-margin-vertical"
                  color="light"
                  fill="outline"
                  @click="modalController.dismiss({ shouldSaveCheck: false })"
                  >Ohne Speichern beenden</ion-button
                >
              </div>
              <!-- <br />
              <a href="#" class="u-color-white" @click.prevent="openInfoModal()"
                >Datenschutzhinweise</a
              > -->
            </template>
            <template v-else>
              <template v-if="isCheckSaved">
                <!-- <p
                  v-if="
                    ['toothCosmetic', 'toothTreatmentplan'].includes(
                      selectedCondition?.name
                    )
                  "
                >
                  Sie finden die Angaben zu Ihrem Anliegen im Menü unter
                  Roodie.Safe und können sie dort jederzeit löschen.
                </p> -->
                <p>
                  Sie finden Ihren Roodie.Check im Menü unter
                  <a
                    class="u-color-white"
                    href="#"
                    @click.prevent="submit('roodie-checks')"
                    >Roodie.Safe</a
                  >
                  und können ihn dort jederzeit teilen oder löschen.
                </p>
              </template>
              <ion-button
                color="light"
                fill="outline"
                @click="submit()"
                :class="{
                  'gtm-appointmentbook-ztk':
                    routing === 'ZTK' && ztkBookingLocation,
                }">
                {{
                  (routing === "ZTK" && ztkBookingLocation) ||
                  (shouldOpenCoaching && routing !== "afterCoaching") ||
                  routing === "Medgate" ||
                  (shouldOpenFormContact &&
                    routing !== "ARAG Case Management Mental")
                    ? "Weiter"
                    : "Beenden"
                }}
              </ion-button>
              <!-- <div
                v-if="routing === 'ZTK' && ztkBookingLocation"
                class="ion-margin-top"
              >
                <ion-button
                  color="light"
                  fill="outline"
                  @click="modalController.dismiss()"
                >
                  Beenden
                </ion-button>
              </div> -->
            </template>
          </ion-col>
          <ion-col
            v-if="routing === 'BetterDoc'"
            class="u-small ion-text-center">
            *Ausführender Partner: BetterDoc GmbH
          </ion-col>
          <ion-col
            v-else-if="routing === 'Quality Smile'"
            class="u-small ion-text-center">
            *Ausführender Partner: Quality Smile GmbH
          </ion-col>
          <ion-col
            v-else-if="routing.startsWith('ARAG Case Management')"
            class="u-small ion-text-center">
            *Ausführender Partner: ARAG Krankenversicherungs-AG
          </ion-col>
        </ion-row>
        <branding v-if="routing !== 'cancel'" style="margin-top: auto" />
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonPage,
  IonContent,
  IonButton,
  IonIcon,
  IonGrid,
  IonRow,
  IonCol,
  modalController,
  IonHeader,
  IonToolbar,
  IonItem,
  IonCheckbox,
  IonLabel,
  IonButtons,
  // IonSpinner,
  // toastController,
} from "@ionic/vue";
import Branding from "@/components/Branding";
import { caretDown, caretUp } from "ionicons/icons";
import { Browser } from "@capacitor/browser";
import Roodie from "@lib/components/svg/Roodie";
import InfoModal from "@lib/components/InfoModal";
import { apiAddUserTag } from "@/api/user";
// import EndModal from "@/components/EndModal";

export default {
  components: {
    IonPage,
    IonContent,
    IonButton,
    IonIcon,
    IonGrid,
    IonRow,
    IonCol,
    IonHeader,
    IonToolbar,
    Branding,
    Roodie,
    IonItem,
    IonCheckbox,
    IonLabel,
    IonButtons,
    // IonSpinner,
  },
  props: {
    routing: {
      required: true,
      type: String,
    },
    ztkBookingText: {
      required: false,
      type: String,
      default: "",
    },
    ztkBookingLocation: {
      required: false,
      type: Object,
      default: null,
    },
    shouldOpenCoaching: {
      required: false,
      type: Boolean,
      default: false,
    },
    shouldOpenInteliwiseModal: {
      required: false,
      type: Boolean,
      default: false,
    },
    shouldOpenFormContact: {
      required: false,
      type: Boolean,
      default: false,
    },
    selectedCondition: {
      required: false,
      type: Object,
      default: null,
    },
    isCheckSaved: {
      required: false,
      type: Boolean,
      default: false,
    },
    hasTreatmentplan: {
      required: false,
      type: Boolean,
      default: false,
    },
    files: {
      required: false,
      type: Array,
      default: null,
    },
    userFiles: {
      required: false,
      type: Array,
      default: null,
    },
    partnerFiles: {
      required: false,
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      modalController: modalController,
      shouldSave: false,
      // isCallTimeOpen: false,
    };
  },
  // mounted() {
  //   if (this.routing === "ZTK" && this.ztkBookingLocation) {
  //     setTimeout(() => {
  //       Browser.open({
  //         url:
  //           "https://dr-flex.de/embed?medicalPracticeId=" +
  //           this.ztkBookingLocation.id,
  //       }).then(() => {
  //         modalController.dismiss();
  //       });
  //     }, 3000);
  //   }
  // },
  computed: {
    privacy3Text() {
      return "<p>Die Angaben zu Ihren Symptomen bzw. Ihrem gesundheitlichen Anliegen werden in Ihrem Nutzerkonto im Menü unter Roodie.Safe gespeichert, damit Sie dort jederzeit auf sie zugreifen können und um bei Aktivierung unseres Benachrichtigungsservices bei Ihnen beispielhaft zu erfragen,  ob ein Termin zu Ihrer Zufriedenheit verlaufen ist, um uns nach Ihrem Wohlbefinden und/oder Genesungsfortschritt zu erkundigen, Sie an Termine zu erinnern und um Ihnen weiterführende Unterstützung von Gesundheitsdienstleistungspartnern zugänglich zu machen.</p><p>Es handelt sich dabei um personenbezogene Daten, die sich auf Ihre körperliche oder mentale Gesundheit, einschließlich der Erbringung von Gesundheitsdienstleistungen beziehen und aus denen Informationen über Ihren Gesundheitszustand hervorgehen. Rechtsgrundlage für die Verarbeitung dieser Daten ist Ihre Einwilligung gemäß Art 9 Abs 2 lit a DSGVO.</p>";
    },
    filesText() {
      let result = "";
      if (
        this.files?.length ||
        this.userFiles?.length ||
        this.partnerFiles?.length
      ) {
        result = "samt (kieferorthopädischem) Behandlungsplan ";
      }
      return result;
    },
  },
  methods: {
    async addUserTag(tag) {
      this.$store.commit("setShowLoading", true);
      const response = await apiAddUserTag(tag);
      if (response.data.Status === "Success") {
        // const toast = await toastController.create({
        //   message:
        //     "Wir informieren Sie, sobald wir in Ihrer Region passende Zahnärzte anbieten können.",
        //   duration: 5000,
        // });
        // toast.present();
        modalController.dismiss({ newRouting: "afterDentistNorthGermanyTag" });
      }
    },
    async openInfoModal(text) {
      const modal = await modalController.create({
        component: InfoModal,
        cssClass: "my-custom-class",
        componentProps: {
          title: "Datenschutzbestimmungen",
          text: text,
        },
      });
      return modal.present();
    },
    submit(routeName) {
      if (this.routing === "Medgate") {
        // window.open(
        //   "https://www.medgate.ch/en-us/for-patients/medgate-app",
        //   "_blank"
        // );
        Browser.open({
          url: "https://www.medgate.ch/en-us/for-patients/medgate-app",
        });
      } else if (this.routing === "ZTK" && this.ztkBookingLocation) {
        Browser.open({
          url:
            "https://dr-flex.de/embed?medicalPracticeId=" +
            this.ztkBookingLocation.id,
        }).then(() => {
          modalController.dismiss();
        });
      } else if (
        this.routing === "ZTK" &&
        !this.ztkBookingLocation &&
        !this.ztkBookingLocation
      ) {
        // const topModal = await modalController.getTop();
        // const modal = await modalController.create({
        //   component: EndModal,
        //   componentProps: {
        //     routing: "afterZTK",
        //   },
        // });
        // modal.onWillDismiss().then(() => {
        //   this.$store.commit("setResetHomeViewForce", true);
        //   topModal.dismiss();
        // });
        // modal.present();
        modalController.dismiss({ newRouting: "afterZTK" });
      } else {
        // this.$store.commit("setShowLoading", true);
        modalController.dismiss({ routeName: routeName });
      }
    },
  },
  setup() {
    return { caretDown, caretUp };
  },
};
</script>

<style lang="scss" scoped>
ion-content {
  --background: var(--ion-color-primary);
  --color: white;
}
</style>
